<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.procedimentosClinicos"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(codigo)="{item}">
                {{formatProcedimento(item.procedimento.codigo)}}
            </template>

            <template v-slot:cell(cid)="{item}">
                {{item.cid ? `${formatCid(item.cid.codigo)} - ${item.cid.nome}` : null}}
            </template>

            <template v-slot:cell(automatico)="{item}">
                {{item.automatico ? 'Sim' : 'Não'}}
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    :disabled="!!item.automatico 
                        && item.procedimento.codigo !== enums.cidObrigatorio.TESTE_RAPIDO_DE_DENGUE_NS1"
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="!!item.automatico"
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Mixins.
import {formats} from '@/mixins'

// Enums.
import cidObrigatorio from '@/enums/ambulatorio/cidObrigatorio'

export default {
    components: {Modal},
    data: () => ({
        fields: [
            {key: 'codigo', label: 'Código', sortable: true},
            {key: 'procedimento.nome', label: 'Nome', sortable: true},
            {key: 'cid', label: 'CID', sortable: true},
            {class: 'col-min', key: 'quantidade', label: 'Quantidade', sortable: true},
            {class: 'col-min', key: 'automatico', label: 'Automático', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
        enums: { cidObrigatorio }
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o procedimento clínico?', async () => {
                this.data.model.procedimentosClinicos.splice(index, 1)
            })
        },
    },
    mixins: [formats],
    props: {
        data: {type: Object, required: true},
    },
}
</script>